import { CancelDeviceModalFormSchema } from './CancelDeviceModal.types'

export const cancelDeviceModalDefaultValues: CancelDeviceModalFormSchema = {
  message: '',
}
